<template>
  <div class="cursor-default" @mousemove="updateMousePosition" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <div v-if="label.length > 0" class="flex flex-nowrap justify-center items-center gap-[8px]">
      <span>{{ label }}</span>
      <slot name="headerIcon"></slot>
    </div>
    <slot></slot>
    <teleport to="body">
      <div
        v-if="isVisible"
        class="fixed flex flex-row items-center bg-white p-[16px] rounded-[8px] text-university-primary gap-x-[8px] font-montserrat font-medium text-sm z-[9999] pointer-events-none"
        style="box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);"
        :style="tooltipStyle"
      >
        <slot name="tooltipIcon"></slot>
        <span>{{ tooltipText }}</span>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  isAbove: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  tooltipText: {
    type: String,
    default: "",
  },
});

const isVisible = ref(false);
const mouseX = ref(0);
const mouseY = ref(0);
const flip = ref(false);

const updateMousePosition = (event) => {
  mouseX.value = event.clientX;
  mouseY.value = event.clientY;

  const screenWidth = window.innerWidth;
  const eightyPercent = 0.8;
  const eightyPercentOfScreen = screenWidth * eightyPercent;
  flip.value = event.clientX > eightyPercentOfScreen;
};

const showTooltip = () => (isVisible.value = true);
const hideTooltip = () => (isVisible.value = false);

const tooltipStyle = computed(() => {
  const offsetX = 10;
  const offsetY = 60;

  if (flip.value) {
    return {
      top: `${mouseY.value - offsetY}px`,
      left: `${mouseX.value - 200}px`, // right to left
    };
  } else {
    return {
      top: `${mouseY.value - offsetY}px`,
      left: `${mouseX.value + offsetX}px`, // left to right
    };
  }
});
</script>
